<template>
  <span v-if="isTable">
    <img
      src="@comm/images/document-conversion/icon_txt.svg"
      class="icon"
      :class="{ isSeach: isSeach }"
      v-if="(fileType == 'ofd' || fileType == 'OFD') && !fileFail"
    />
    <img
      src="@comm/images/document-conversion/ofd_pl.svg"
      class="icon"
      :class="{ isSeach: isSeach }"
      v-if="(fileType == 'ofd' || fileType == 'OFD') && fileFail"
    />
    <img
      src="@comm/images/document-conversion/icon_pdf.svg"
      class="icon"
      :class="{ isSeach: isSeach }"
      v-if="(fileType == 'pdf' || fileType == 'PDF') && !fileFail"
    />
    <img
      src="@comm/images/document-conversion/pdf_pl.svg"
      class="icon"
      :class="{ isSeach: isSeach }"
      v-if="(fileType == 'pdf' || fileType == 'PDF') && fileFail"
    />
    <img
      src="@comm/images/document-conversion/icon_doc.svg"
      class="icon"
      :class="{ isSeach: isSeach }"
      v-if="
        (fileType == 'doc' ||
          fileType == 'docx' ||
          fileType == 'DOC' ||
          fileType == 'DOCX') &&
        !fileFail
      "
    />
    <img
      src="@comm/images/document-conversion/icon_doc_fail.svg"
      class="icon"
      :class="{ isSeach: isSeach }"
      v-if="
        (fileType == 'doc' ||
          fileType == 'docx' ||
          fileType == 'DOC' ||
          fileType == 'DOCX') &&
        fileFail
      "
    />
    <img
      src="@comm/images/document-conversion/icon_excel.svg"
      class="icon"
      :class="{ isSeach: isSeach }"
      v-if="
        (fileType == 'xlsx' ||
          fileType == 'xls' ||
          fileType == 'XLSX' ||
          fileType == 'XLS') &&
        !fileFail
      "
    />
    <img
      src="@comm/images/document-conversion/icon_excel_fail.svg"
      class="icon"
      :class="{ isSeach: isSeach }"
      v-if="
        (fileType == 'xlsx' ||
          fileType == 'xls' ||
          fileType == 'XLSX' ||
          fileType == 'XLS') &&
        fileFail
      "
    />
    <img
      src="@comm/images/document-conversion/icon_jpg.svg"
      class="icon"
      :class="{ isSeach: isSeach }"
      v-if="
        (fileType == 'jpg' ||
          fileType == 'JPG' ||
          fileType == 'png' ||
          fileType == 'PNG' ||
          fileType == 'tif' ||
          fileType == 'TIF' ||
          fileType == 'tiff' ||
          fileType == 'TIFF' ||
          fileType == 'bmp' ||
          fileType == 'BMP') &&
        !fileFail
      "
    />
    <img
      src="@comm/images/document-conversion/img_pl.svg"
      class="icon"
      :class="{ isSeach: isSeach }"
      v-if="
        (fileType == 'jpg' ||
          fileType == 'JPG' ||
          fileType == 'png' ||
          fileType == 'PNG' ||
          fileType == 'tif' ||
          fileType == 'TIF' ||
          fileType == 'tiff' ||
          fileType == 'TIFF' ||
          fileType == 'bmp' ||
          fileType == 'BMP') &&
        fileFail
      "
    />
    <img
      src="@comm/images/document-conversion/icon_ppt.svg"
      class="icon"
      :class="{ isSeach: isSeach }"
      v-if="
        (fileType == 'ppt' ||
          fileType == 'pptx' ||
          fileType == 'PPT' ||
          fileType == 'PPTX') &&
        !fileFail
      "
    />
    <img
      src="@comm/images/document-conversion/icon_ppt_fail.svg"
      class="icon"
      :class="{ isSeach: isSeach }"
      v-if="
        (fileType == 'ppt' ||
          fileType == 'pptx' ||
          fileType == 'PPT' ||
          fileType == 'PPTX') &&
        fileFail
      "
    />
        <img
      src="@comm/images/document-conversion/icon_wps.svg"
      class="icon"
      :class="{ isSeach: isSeach }"
      v-if="
        (fileType == 'wps' ||
          fileType == 'WPS') &&
        !fileFail
      "
    />
    <img
      src="@comm/images/document-conversion/icon_wps_fail.svg"
      class="icon"
      :class="{ isSeach: isSeach }"
      v-if="
        (fileType == 'wps' ||
          fileType == 'WPS') &&
        fileFail
      "
    />
    <img
      src="@comm/images/document-conversion/icon_other.svg"
      class="icon"
      :class="{ isSeach: isSeach }"
      v-if="
        ((fileType != 'ofd' &&
          fileType != 'OFD' &&
          fileType != 'pdf' &&
          fileType != 'PDF' &&
          fileType != 'doc' &&
          fileType != 'DOC' &&
          fileType != 'docx' &&
          fileType != 'DOCX' &&
          fileType != 'xlsx' &&
          fileType != 'XLSX' &&
          fileType != 'xls' &&
          fileType != 'XLS' &&
          fileType != 'jpg' &&
          fileType != 'JPG' &&
          fileType != 'png' &&
          fileType != 'PNG' &&
          fileType != 'tif' &&
          fileType != 'TIF' &&
          fileType != 'tiff' &&
          fileType != 'TIFF' &&
          fileType != 'bmp' &&
          fileType != 'BMP'&&
          fileType != 'ppt' &&
          fileType != 'PPT' &&
          fileType != 'pptx' &&
          fileType != 'wps' &&
          fileType != 'WPS' &&
          fileType != 'PPTX')||fileType == 'gif'||fileType == 'GIF'||
          !fileType) &&
        !fileFail
      "
    />
    <img
      src="@comm/images/document-conversion/icon_other_fail.svg"
      class="icon"
      :class="{ isSeach: isSeach }"
      v-if="
        ((fileType != 'ofd' &&
          fileType != 'OFD' &&
          fileType != 'pdf' &&
          fileType != 'PDF' &&
          fileType != 'doc' &&
          fileType != 'DOC' &&
          fileType != 'docx' &&
          fileType != 'DOCX' &&
          fileType != 'xlsx' &&
          fileType != 'XLSX' &&
          fileType != 'xls' &&
          fileType != 'XLS' &&
          fileType != 'jpg' &&
          fileType != 'JPG' &&
          fileType != 'png' &&
          fileType != 'PNG' &&
          fileType != 'tif' &&
          fileType != 'TIF' &&
          fileType != 'tiff' &&
          fileType != 'TIFF' &&
          fileType != 'bmp' &&
          fileType != 'BMP'&&
          fileType != 'ppt' &&
          fileType != 'PPT' &&
          fileType != 'pptx' &&
          fileType != 'wps' &&
          fileType != 'WPS' &&
          fileType != 'PPTX')||fileType == 'gif'||fileType == 'GIF'||
          !fileType) &&
        fileFail
      "
    />
  </span>
</template>

<script>
export default {
  name: "iconImg",
  props: {
    type: "",
    fileType: "",
    isTable: false,
    isSeach: false,
    fileFail: false,
  },
};
</script>

<style scoped lang="scss">
.fm {
  width: 60%;
}
.fm .icon {
  width: auto;
  height: 98px;
  margin: 0 auto 12px;
  display: block;
}
.icon {
  width: 24px;
  height: 24px;
  display: inline-block;
  vertical-align: middle;
  &.isSeach {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/document-conversion/iconImg/index.vue